<div class="main-container">
    <!-- First Container -->
    <app-hero-banner [heroImages]="heroImages" [overlayImages]="overlayImages" [overlayText]="overlayText"
        [ourstory]="ourstory"></app-hero-banner>
    <div class="middle-container">
        <h3>The future of health care demands bold action</h3>
        <p>Ascendiun oversees four forward-thinking companies, guided by the goal of transforming a dysfunctional
            American health care system into one worthy of our family and friends and sustainably affordable for
            everyone.</p>
    </div>
    <!-- Second Container -->
    <div class="second-container">
        <div class="column fir-col">
            <picture>
                @for (item of peopleImages; track item) {
                <source media="(max-width: {{item.maxWidth}}px)" srcset="assets/img/plans/{{item.image}}">
                @if (item.maxWidth === 1800) {
                <img src="assets/img/plans/{{item.image}}" alt="plans">
                }
                }
            </picture>
        </div>
        <div class="column pd-left-align sec-col">
            <div class="people-content">
                @for (item of peopleContent; track item; let i = $index) {
                <div class="people-sub-content">
                    <div class="people-header">{{item.title}}</div>
                    <div class="people-body">{{item.description}} </div>
                    <div class="people-links">
                        <a class="people-link-content" (click)="openLink(item.linkPath)"
                            (keyup)="openLink(item.linkPath)" tabindex="0">{{item.linkText}}</a>
                        <img alt="arrow-icon" class="people-link-arrow" (click)="openLink(item.linkPath)"
                            (keyup)="openLink(item.linkPath)" src="assets/img/svgs/_Arrow.svg" tabindex="0">
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
<!-- Footer Container -->
<div class="footer">
    <img src="assets/img/footer/Ascendiun_Black-L.png" alt="Footer" class="footer-image">
    <a class="footer-link" [href]="mail_text">Contact us</a>
</div>